"use client";

import clsx from "clsx";

type Props = {
  orientation?: "horizontal" | "vertical";
  className?: string;
  decorative?: boolean;
};

export function Separator({
  orientation = "horizontal",
  className,
  decorative = true,
}: Props) {
  return (
    <div
      role={decorative ? "none" : "separator"}
      aria-orientation={decorative ? undefined : orientation}
      data-orientation={orientation}
      className={clsx(
        "bg-sbeige shrink-0",
        orientation === "horizontal" ? "h-px w-full" : "w-px self-stretch",
        className,
      )}
    />
  );
}
